import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import Header from './header';
import { Icons } from "../assest/icons";
import { logger } from '../utils/logger';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { getInsuranceData, createInsuranceData, updateInsuranceData, updateUser } from '../services/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase.config';
import LoaderSpinner from './loaderSpinner';


function UserMyInsurance() {
 
  const userDataInfo =  JSON.parse(localStorage.getItem('UserProfile')) || {};
  // const myinsuranceData =  JSON.parse(localStorage.getItem('myinsuranceinfo'))
  const [myinsuranceData, setMyinsuranceData] = useState([]);

  const userID =  JSON.parse(localStorage.getItem('UserId'));
  const [ShowLoaderPage, setShowLoaderPage] = useState(false);

  const location = useLocation();
  
  const [policyIDTxt, setpolicyIDTxt] = useState(myinsuranceData?.policy_id  || '');
  const [GroupIDTxt, setGroupIDTxt] = useState(myinsuranceData?.group_id || '');
  const [GroupNameTxt, setGroupNameTxt] = useState(myinsuranceData?.group_name || '');
  const [InsuranceCarrierTxt, setInsuranceCarrierTxt] = useState(myinsuranceData?.insurance_carrier || '');
  const [DOBTxt, setDOBTxt] = useState(myinsuranceData?.expiry_date || '');
  const [selectedFrontImage, setSelectedFrontImage] = useState(myinsuranceData?.front_image || '');
  const [frontPreview, setFrontPreview] = useState(myinsuranceData?.front_image || '');
  const [selectedBackImage, setSelectedBackImage] = useState(myinsuranceData?.back_image || '');
  const [backPreview, setBackPreview] = useState(myinsuranceData?.back_image || '');
  const [DOBTxtEnter, setDOBTxtEnter] = useState('');
  
  const [profile, setProfile] = useState({
    policyIDTxt: myinsuranceData?.policy_id || '',
    GroupIDTxt: myinsuranceData?.group_id || '',
    GroupNameTxt: myinsuranceData?.group_name || '',
    InsuranceCarrierTxt: myinsuranceData?.insurance_carrier || '',
    DOBTxt: myinsuranceData?.expiry_date || '',
    selectedFrontImage: myinsuranceData?.front_image || '',
    selectedBackImage: myinsuranceData?.back_image || '',
  });
  
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [originalProfile, setOriginalProfile] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [isNewCard, setNewCard] = useState(false);
  
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [error, setError] = useState('');
  const [ShowLoader, setShowLoader] = useState(false);


  const [UserId, setUserId] = useState(userDataInfo?.user_id || userDataInfo?.id || '');
  const [isValid, setIsValid] = useState(false);

  const frontFileInputRef = useRef(null);  // Ref for Front file input
  const backFileInputRef = useRef(null);   // Ref for Back file input
 
 // Separate states for immediate validation and form submission errors
 const [formChkErrors, setFormChkErrors] = useState({ frontError: '', backError: '' });

 const [isfrontFileSubmitted, setIsfrontFileSubmitted] = useState(false); 
 const [isbackFileSubmitted, setIsbackFileSubmitted] = useState(false);
 const [CheckExpiry, setCheckExpiry] = useState(false);  
  
 
    
  useEffect(() => {
    handleMyInsurance();
    if (UserId) {
      localStorage.setItem('UserId', JSON.stringify(UserId));
    }
  }, [UserId]);
   
 
const formatDate = (date) => { 
  return date ? moment(date).format("YYYY-MM-DD") : '';
};
const handleChangeCancel = () => { 
    setIsEditing(!isEditing);
};
 
const handleMyInsurance = async () => {
  setShowLoaderPage(true);

  try {
    const lookupId = UserId || userID;

    if (!lookupId) {
      setNewCard(true);
      setIsEditing(true);
      return;
    }

    const insuranceList = await getInsuranceData(lookupId);
    const firstRecord = insuranceList && insuranceList.length > 0 ? insuranceList[0] : null;
    const hasMeaningfulData = firstRecord && (
      firstRecord.policy_id ||
      firstRecord.group_name ||
      firstRecord.insurance_carrier ||
      firstRecord.expiry_date
    );

    if (firstRecord && hasMeaningfulData) {
      setpolicyIDTxt(firstRecord.policy_id || '');
      setGroupIDTxt(firstRecord.group_id || '');
      setGroupNameTxt(firstRecord.group_name || '');
      setInsuranceCarrierTxt(firstRecord.insurance_carrier || '');
      setDOBTxt(firstRecord.expiry_date || '');
      setDOBTxtEnter(firstRecord.expiry_date || '');
      setSelectedFrontImage(firstRecord.front_image || '');
      setFrontPreview(firstRecord.front_image || '');
      setSelectedBackImage(firstRecord.back_image || '');
      setBackPreview(firstRecord.back_image || '');

      setProfile((prevProfile) => ({
        ...prevProfile,
        policyIDTxt: firstRecord.policy_id || '',
        GroupIDTxt: firstRecord.group_id || '',
        GroupNameTxt: firstRecord.group_name || '',
        InsuranceCarrierTxt: firstRecord.insurance_carrier || '',
        DOBTxt: firstRecord.expiry_date || '',
        DOBTxtEnter: firstRecord.expiry_date || '',
        selectedFrontImage: firstRecord.front_image || '',
        selectedBackImage: firstRecord.back_image || '',
      }));

      localStorage.setItem('myinsuranceinfo', JSON.stringify(firstRecord));
      setMyinsuranceData(firstRecord);
      setNewCard(false);

      const expiry = moment(firstRecord.expiry_date);
      setCheckExpiry(expiry.isValid() && expiry.isAfter(moment(), 'day'));
    } else {
      // Either no record at all, or an existing-but-empty record left from an earlier flow.
      // In both cases, let the user fill the form and decide on save whether to update or create.
      setNewCard(!firstRecord);
      setIsEditing(true);
    }
  } catch (error) {
    logger.error('Error fetching insurance:', error);
    // On fetch error, still let the user fill the form
    setNewCard(true);
    setIsEditing(true);
  } finally {
    setShowLoaderPage(false);
  }
};
 
const handleChange = (e) => {
  const { name, value } = e.target; 
  setProfile((prevState) => ({
    ...prevState,
    [name]: value,
  }));
};

const handleSubmitProfile = async (event) => {
  event.preventDefault();
  let newDOBTxt = '';
  let formErrors = {};
  
  // Validation logic
  if (!YYYYTxt.trim() || !MMTxt.trim() || !DDTxt.trim()) {
    formErrors.DOBTxt = 'Please select a complete date (YYYY/MM/DD)';
  } else {
    const year = parseInt(YYYYTxt, 10);
    const month = parseInt(MMTxt, 10);
    const day = parseInt(DDTxt, 10);
    const maxAllowedDate = moment().add(20, 'years').endOf('day');
    const minAllowedDate = moment().subtract(20, 'years').startOf('day');
    const date = moment(`${YYYYTxt}-${MMTxt}-${DDTxt}`, 'YYYY-MM-DD');

    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      formErrors.DOBTxt = 'Invalid input. Ensure all fields are numbers';
    } else if (month < 1 || month > 12) {
      formErrors.DOBTxt = 'Invalid month. Month must be between 1 and 12';
    } else if (day < 1 || day > 31) {
      formErrors.DOBTxt = 'Invalid day. Day must be between 1 and 31';
    } else if (!date.isValid()) {
      formErrors.DOBTxt = 'Invalid date. Please check your input (e.g., Feb 30 is not valid)';
    } else if (date.isBefore(minAllowedDate, 'day')) {
      formErrors.DOBTxt = `Date cannot be more than 20 years in the past`;
    } else if (date.isAfter(maxAllowedDate, 'day')) {
      formErrors.DOBTxt = `Date cannot be more than 20 years in the future`;
    } else {
      newDOBTxt = date.format('YYYY-MM-DD'); // Set newDOBTxt with the valid date
      setDOBTxt(newDOBTxt); // Update state
    }
  }


  

  // Check for other required fields
  if (!policyIDTxt.trim()) {
    formErrors.policyIDTxt = 'Please enter your Policy ID';
  }
  if (!GroupNameTxt.trim()) {
    formErrors.GroupNameTxt = 'Please enter your Group Name';
  }
  if (!InsuranceCarrierTxt.trim()) {
    formErrors.InsuranceCarrierTxt = 'Please enter your Insurance Carrier';
  }

  // Stop execution if there are validation errors
  if (Object.keys(formErrors).length > 0) {
    setError(formErrors);
    return;
  }

  try {
    // Upload images to Firebase Storage if they are new files
    let frontImageUrl = selectedFrontImage;
    let backImageUrl = selectedBackImage;
    
    if (selectedFrontImage && typeof selectedFrontImage !== 'string') {
      const frontRef = ref(storage, `insurance/${UserId}/front_${Date.now()}.jpg`);
      await uploadBytes(frontRef, selectedFrontImage);
      frontImageUrl = await getDownloadURL(frontRef);
    }
    
    if (selectedBackImage && typeof selectedBackImage !== 'string') {
      const backRef = ref(storage, `insurance/${UserId}/back_${Date.now()}.jpg`);
      await uploadBytes(backRef, selectedBackImage);
      backImageUrl = await getDownloadURL(backRef);
    }
    
    // Prepare insurance data
    const insuranceData = {
      expiry_date: newDOBTxt,
      group_name: GroupNameTxt,
      policy_id: policyIDTxt,
      insurance_carrier: InsuranceCarrierTxt,
      front_image: frontImageUrl,
      back_image: backImageUrl
    };
    
    const ownerId = UserId || userID;
    if (!ownerId) {
      throw new Error('Missing user identifier. Please log in again.');
    }

    if (isNewCard) {
      insuranceData.user_id = ownerId;
      await createInsuranceData(insuranceData);
    } else {
      // Get the insurance document ID from the existing data
      const insuranceList = await getInsuranceData(ownerId);
      if (insuranceList && insuranceList.length > 0) {
        await updateInsuranceData(insuranceList[0].id, insuranceData);
      } else {
        // No record found — fall through to creating a new one
        insuranceData.user_id = ownerId;
        await createInsuranceData(insuranceData);
      }
    }
    
    // Sync policy_id back to the user document so the admin dashboard shows it
    try {
      await updateUser(ownerId, { insurance: policyIDTxt });
    } catch (e) {
      logger.warn('Could not sync insurance ID to user profile:', e);
    }

    toast.success("Insurance details updated successfully!", {
      position: toast.POSITION.TOP_RIGHT,
    });

    // Update localStorage so patient portal shows updated data immediately
    const updatedInsurance = { ...insuranceData, user_id: ownerId };
    localStorage.setItem('myinsuranceinfo', JSON.stringify(updatedInsurance));

    const currentDate = moment();
    const expiry = moment(newDOBTxt);

    if (expiry.isAfter(currentDate, 'day')) {
      setCheckExpiry(true);
    } else {
      setCheckExpiry(false);
    }

    setShowLoader(false);
    setError('');
    handleCancel();
  } catch (error) {
    logger.error('Error submitting insurance:', error);
    toast.error(error.message || "Failed to update insurance details. Please try again.", {
      position: toast.POSITION.TOP_RIGHT,
    });
    setError('');
    setShowLoader(false);
  }
};


const handleCancel = () => { 
  // setProfile(originalProfile);
  // setIsEditing(false);
  // setError('') 
  window.location.reload(); 

};

const handleInsuraneCarrierChange = (event) => {
  // Remove non-text characters from the input value
  const value = event.target.value.replace(/[^a-zA-Z0-9\s]/g, ''); //.replace(/[^a-zA-Z\s]/g, '');
  setInsuranceCarrierTxt(value);   
};
 

const handleGroupNameChange = (event) => {
  // Remove non-text characters from the input value
  // const value = event.target.value.replace(/[^a-zA-Z\s]/g, '');
  const value = event.target.value.replace(/[^a-zA-Z0-9\s]/g, '');//.replace(/[^a-zA-Z\s]/g, '');
  setGroupNameTxt(value); 
};


const InsuranceIdHandleChange = (e) => {
  // Get the new value
  const value = e.target.value;    

  // Regex to allow only alphanumeric characters, hyphens, and spaces
  const regex = /^[\w\s-]*$/;

  if (value === '' || regex.test(value)) {
    let newValue = value.replace(/\s+/g, ' '); 
    setpolicyIDTxt(newValue);
  }  
};

 
 



const yearRef = useRef(null);
const monthRef = useRef(null);
const dayRef = useRef(null);
  
const [YYYYTxt, setYYYYTxt] = useState('');
const [MMTxt, setMMTxt] = useState('');
const [DDTxt, setDDTxt] = useState('');

useEffect(() => {
  if (DOBTxt) {
    try {
      // Convert DOBTxt to string if it's a Date object or Timestamp
      const dobString = typeof DOBTxt === 'string' ? DOBTxt :
                        DOBTxt instanceof Date ? DOBTxt.toISOString().split('T')[0] :
                        DOBTxt.toDate ? DOBTxt.toDate().toISOString().split('T')[0] : '';
      
      if (dobString && dobString.includes('-')) {
        const parts = dobString.split('-');
        if (parts.length === 3) {
          const [year, month, day] = parts;
          setYYYYTxt(year || '');
          setMMTxt(month || '');
          setDDTxt(day || '');
        }
      }
    } catch (error) {
      logger.error('Error parsing DOBTxt:', error);
    }
  }
}, [DOBTxt]);

const handleInput = (e, nextRef, prevRef, setState) => {
    let value = e.target.value;
    const fieldName = e.target.placeholder;
    // Reset submission flag when user types
    setIsSubmitted(false); 

    // Update the state as the user types
    setState(value); 

  // Forward jump when the max length is reached
  // if (value.length === e.target.maxLength) {
    
  //   if (fieldName === "YYYY") {
  //     const currentYear = moment().year();
  //     const maxAllowedYear = currentYear + 2; // Allow up to 2 years from the current year
  //     if (parseInt(value, 10) > maxAllowedYear) {
  //       setErrorMessage(`Year cannot be more than ${maxAllowedYear}`);
  //       yearRef.current.focus();
  //       return;
  //     }
  //   }

  //   // Month Validation (MM)
  //   if (fieldName === "MM") {
  //     if (parseInt(value, 10) < 1 || parseInt(value, 10) > 12) {
  //       setErrorMessage("Month must be between 1 and 12");
  //       monthRef.current.focus();
  //       return;
  //     }
  //   }

  //   // Day Validation (DD)
  //   if (fieldName === "DD") {
  //     if (parseInt(value, 10) < 1 || parseInt(value, 10) > 31) {
  //       setErrorMessage("Day must be between 1 and 31");
  //       dayRef.current.focus();
  //       return;
  //     }
  //   }

  if (value.length === e.target.maxLength) { 
    const currentDate = moment();
    const enteredYear = parseInt(YYYYTxt, 10);
    const enteredMonth = parseInt(MMTxt, 10) - 1; 
   

    if (fieldName === "YYYY") {
        if (enteredYear < 1000 || enteredYear > 9999) {
            setErrorMessage("Invalid year");
            yearRef.current.focus();
            return;
        }
        if (enteredYear > currentDate.year()) {
            setErrorMessage("Year cannot be in the future");
            yearRef.current.focus();
            return;
        }
    }

    if (fieldName === "MM") {
      if (parseInt(value, 10) < 1 || parseInt(value, 10) > 12) {
          setErrorMessage("Month must be between 1 and 12");
          monthRef.current.focus();
          return;
      }
      if (enteredYear === currentDate.year() && parseInt(value, 10) > currentDate.month() + 1) {
          setErrorMessage("Month cannot be in the future");
          monthRef.current.focus();
          return;
      }
  }

  if (fieldName === "DD") {
    const currentDateN = moment().startOf("day");
    const enteredDayNum = parseInt(value, 10); // Convert input value to number
    const enteredDate = moment({
      year: enteredYear,
      month: enteredMonth,
      day: enteredDayNum  
    }).startOf("day");

  

    // Reject invalid day numbers immediately
    if (enteredDayNum < 1 || enteredDayNum > 31) {
        setErrorMessage("Day must be between 1 and 31"); 
        dayRef.current.focus();
        return;
    }


  if (enteredDate.isAfter(currentDateN, 'day')) {
    setErrorMessage("Date cannot be in the future");
    dayRef.current.focus();
    return;
}

    if (!enteredDate.isValid()) {
        setErrorMessage("Invalid date. Please check your input.");
        dayRef.current.focus();
        return;
    }
 
}

    // Clear error message if validation passes
    setErrorMessage("");
    if (nextRef) {
      nextRef.current.focus();
    }
  } 
  // Backward jump when "Backspace" is pressed and the input is empty
  else if (e.nativeEvent.inputType === "deleteContentBackward" && value.length === 0) {
    if (prevRef) {
      prevRef.current.focus();
    }
  }
 
};

  

const handleKeyDown = (e, nextRef, prevRef, setState) => {
  const value = e.target.value;
  const fieldName = e.target.placeholder;

  // Handle Right Arrow Key
  if (e.key === "ArrowRight") {
    if (value === "") {
      setErrorMessage(`${fieldName} cannot be empty`);
      e.target.focus();
      return;
    } else {
      setErrorMessage(""); // Clear error if field is not empty
    }

    // Check for single-digit values in MM and DD
    if ((fieldName === "MM" || fieldName === "DD") && value.length === 1) {
      const paddedValue = `0${value}`; // Add leading zero
      setState(paddedValue); // Update state
      e.target.value = paddedValue; // Update input value
    }

    if (nextRef) {
      nextRef.current.focus();
    }
  }

  // Handle Left Arrow Key
  if (e.key === "ArrowLeft") {
    if (value === "") {
      setErrorMessage(`${fieldName} cannot be empty`);
      e.target.focus();
      return;
    } else {
      setErrorMessage(""); // Clear error if field is not empty
    }

    // Check for single-digit values in MM and DD
    if ((fieldName === "MM" || fieldName === "DD") && value.length === 1) {
      const paddedValue = `0${value}`; // Add leading zero
      setState(paddedValue); // Update state
      e.target.value = paddedValue; // Update input value
    }

    if (prevRef) {
      prevRef.current.focus();
    }
  }
};

const handleBlur = (e, setState) => {
  const value = e.target.value;

  // Check if the value is a single digit
  if (value.length === 1 && parseInt(value, 10) > 0) {
    const paddedValue = `0${value}`; // Add leading zero
    setState(paddedValue); // Update state
    e.target.value = paddedValue; // Update input value
  }
};  

// Handles the file input change
const handleImageChange = (e, type) => {
  const file = e.target.files[0]; 
  let errors = { ...formChkErrors };

  // Reset submission flags
  if (type === 'front') setIsfrontFileSubmitted(false);
  if (type === 'back') setIsbackFileSubmitted(false);

  if (file && (file.type === "image/jpeg" || file.type === "image/png")) {
    
    // Check if the same file is being uploaded for both front and back
    if (type === 'front' && selectedBackImage && selectedBackImage.name === file.name) {
      errors.frontError = 'Front image cannot be the same as the back image';
    } else if (type === 'back' && selectedFrontImage && selectedFrontImage.name === file.name) {
      errors.backError = 'Back image cannot be the same as the front image';
    } else {
      // Proceed with normal file upload handling
      const reader = new FileReader();
      reader.onloadend = () => {
        if (type === 'front') setFrontPreview(reader.result);
        else if (type === 'back') setBackPreview(reader.result);
      };
      reader.readAsDataURL(file);
      if (type === 'front') {
        setSelectedFrontImage(file);
        errors.frontError = '';  // Clear any previous front image errors
      } else if (type === 'back') {
        setSelectedBackImage(file);
        errors.backError = '';  // Clear any previous back image errors
      }
    }

  } else {
    if (type === 'front') {
      errors.frontError = 'Please upload an image file (jpg or png)';
    } else if (type === 'back') {
      errors.backError = 'Please upload an image file (jpg or png)';
    }
  }

  setFormChkErrors(errors);  // Update form errors state
};

// Function to trigger the hidden file input click
const handleUploadClick = (type, e) => {
  e.stopPropagation(); // Stop the click event from bubbling
  e.preventDefault();  // Prevent default behavior if necessary

  if (type === 'front') {
    frontFileInputRef.current.click();  // Trigger Front input
  } else if (type === 'back') {
    backFileInputRef.current.click();   // Trigger Back input
  }
};

  // Reset file and preview
  const resetImage = (type) => {
    let errors = { ...formChkErrors };
    if (type === 'front') {
      setSelectedFrontImage(null);
      setFrontPreview(null);
      errors.frontError = '';  // Clear front image error when reset
    } else if (type === 'back') {
      setSelectedBackImage(null);
      setBackPreview(null);
      errors.backError = '';  // Clear back image error when reset
    }
    setFormChkErrors(errors);  // Update form errors state
  };



  return (
    <div > 
     <div className='container-fluid p-0 bgInnerDiv'>
        <Header />
        <div className='container-fluid p-0 contentBody  '>  
        {ShowLoaderPage && <LoaderSpinner />} 

        <div className='loginBoxDiv ForgotPassswordMain myinsuranceinfoMain whiteBgColor centerDivAlign'> 
        <h2>My Insurance
             <button className={'editIcon ' + (isEditing ?  'btnactive' : '') } onClick={() => setIsEditing(true)}>Edit
           <img src={isEditing ? Icons[0].editRed : Icons[0].editIcon } className="logoImg" alt="" /> 
           </button>
        </h2> 
        {CheckExpiry &&
              <h3 className='errorCardExpiry'  > <img src={Icons[0].errorImg} style={{width:'24px', marginRight:'5px'}} /> Health card has expired </h3>
        } 
       <form onSubmit={handleSubmitProfile}> 
     
       <fieldset className='editmyinsuranceinfo MyInsuranceInnerDiv'  id="sign_up" >
          <div className='inputDivBox' >
            <label>Insurance Carrier:</label>
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                    <img src={Icons[0].InsuranceIDIcon} className="logoImg" alt="" />
                    <input type="text" value={InsuranceCarrierTxt} placeholder="Insurance Carrier" onChange={handleInsuraneCarrierChange} disabled={isEditing ? '' : 'true'}    />
            </div>
            {error.InsuranceCarrierTxt && <span  className="errorTxt" >{error.InsuranceCarrierTxt}</span>} 
          </div>
          <div className='inputDivBox' >
            <label>Policy ID:</label>
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                    <img src={Icons[0].policyidIcon} className="logoImg" alt="" />
                    <input type="text" value={policyIDTxt} placeholder="Policy ID" disabled={isEditing ? '' : 'true'} onChange={InsuranceIdHandleChange}    /> 
                  </div>
                  {error.policyIDTxt && <span  className="errorTxt" >{error.policyIDTxt}</span>}  

          </div> 
          <div className='inputDivBox' >
            <label>Group Name:</label>
            <div className={"inputTxtBox  registerInputDiv " + (isEditing ? '' : 'disabled')}>
                    <img src={Icons[0].groupnameIcon} className="logoImg" alt="" />
                    <input type="text" value={GroupNameTxt} placeholder="Group Name" disabled={isEditing ? '' : 'true'} onChange={handleGroupNameChange}    /> 
                  </div>
                  {error.GroupNameTxt && <span  className="errorTxt" >{error.GroupNameTxt}</span>} 
          </div> 
          <div className='inputDivBox' >
            <label>
              {/* Expiry Validity */}
            Effective Date:</label>  
            {/* CheckExpiry */}
            <div className={"inputTxtNewBox  registerInputDiv " + (isEditing ? '' : 'disabled') + (CheckExpiry && ' dateExpiryTxt') }>
                        <img src={Icons[0].expirydateIcon} className="logoImg" alt="" />
                        {/* <input type="text" value={DOBTxt} placeholder="Date of Birth (YYYY-MM-DD)" disabled={isEditing ? '' : 'true'}  />  */}

                         <div className="timepicker">
                              <input
                                type="text"
                                className="hh"
                                maxLength="4"
                                placeholder="YYYY"
                                ref={yearRef}
                                value={YYYYTxt}
                                disabled={isEditing ? '' : 'true'} 
                                onInput={(e) => handleInput(e, monthRef, null, setYYYYTxt)}
                                onKeyDown={(e) => handleKeyDown(e, monthRef, null)}
                              />
                              /
                              <input
                                type="text"
                                className="mm"
                                maxLength="2"
                                placeholder="MM"
                                value={MMTxt}
                                ref={monthRef}
                                disabled={isEditing ? '' : 'true'} 
                                  onInput={(e) => handleInput(e, dayRef, yearRef, setMMTxt)}
                                  onKeyDown={(e) => handleKeyDown(e, dayRef, yearRef, setMMTxt)}
                              />
                              /
                              <input
                                type="text"
                                className="mm"
                                maxLength="2"
                                placeholder="DD"
                                ref={dayRef}
                                value={DDTxt}
                                disabled={isEditing ? '' : 'true'} 
                                onInput={(e) => handleInput(e, null, monthRef, setDDTxt)}
                                onKeyDown={(e) => handleKeyDown(e, null, monthRef, setDDTxt)}
                                onBlur={(e) => handleBlur(e, setDDTxt)} // Add onBlur event
                              />
                              <b style={{fontWeight:'500',fontSize: '14px', color:'#999'}}>
                              Effective Date
                              {/* Expiry Validity */}
                              </b>
                           
                            </div>   
                   </div>
                  {error.DOBTxt && <span  className="errorTxt" >{error.DOBTxt}</span>} 
          </div>
          <div className='inputDivBox' >
            <label>Front Side:</label> 
            <div className={"inputTxtBox cardImageDiv registerInputDiv " + (isEditing ? '' : 'disabled')}>
                    {/* <img src={selectedFrontImage} className="logoImg" alt="" />  */}
                    <b className='myinsurancecardImg'>
                         {/* Custom Upload Button for Front Image */}
                    {!selectedFrontImage && ( 
                       <span className='uploadInnerDiv'> 
                          <img src={Icons[0].uploadIcon} className="logoImg uploadIcon" alt="" /> 
                          <span className='cardUploadTxt'>Insurance Card Front {" "}
                            <button className="cardImgBtn" onClick={(e) => handleUploadClick('front', e)}>
                                Browse
                            </button> 
                          </span> 
                          <span  className='cardUploadTxt'>File Format - PNG JPG | File Size - 5 MB (Max)</span>
                      
                        {/* Hidden Front file input */}
                        <input 
                          type="file" 
                          accept="image/jpeg, image/png" 
                          ref={frontFileInputRef} 
                          onChange={(e) => handleImageChange(e, 'front')}
                          style={{ display: 'none' }} 
                        />
                     </span>
                    )} 

                        
                    {frontPreview && (
                      <span className="previewImg"> 
                        <b><img src={frontPreview} alt="Front Preview" /></b> 
                        <button className={"removedBtn "+ (isEditing ? '' : 'd-none') } onClick={() => resetImage('front')}>&#10006;</button>
                      </span>
                    )}
                    </b>
                  </div>
                  {error.InsuranceIdTxt && <span  className="errorTxt" >{error.InsuranceIdTxt}</span>} 
          </div>
          
          <div className='inputDivBox' >
            <label>Back Side:</label> 
            <div className={"inputTxtBox cardImageDiv registerInputDiv " + (isEditing ? '' : 'disabled')}>
                    {/* <img src={selectedBackImage} className="logoImg" alt="" />  */}
                   <b className='myinsurancecardImg'>
                     {/* Custom Upload Button for Back Image */}
                      {!selectedBackImage && (
                        <span className='uploadInnerDiv'> 
                          <img src={Icons[0].uploadIcon} className="logoImg uploadIcon" alt="" /> 
                          <span className='cardUploadTxt'>Insurance Card Back {" "}
                            <button className="cardImgBtn" onClick={(e) => handleUploadClick('back', e)}>
                                Browse
                            </button> 
                          </span> 
                          <span  className='cardUploadTxt'>File Format - PNG JPG | File Size - 5 MB (Max)</span>
                          {/* Hidden Back file input */}
                          <input 
                            type="file" 
                            accept="image/jpeg, image/png" 
                            ref={backFileInputRef} 
                            onChange={(e) => handleImageChange(e, 'back')}
                            style={{ display: 'none' }} 
                          />
                        </span>
                      )}

                      {backPreview && (
                        <span className="previewImg"> 
                          <b><img src={backPreview} alt="Back Preview" /></b>
                          <button className={"removedBtn "+ (isEditing ? '' : 'd-none') }  onClick={() => resetImage('back')}>&#10006;</button>
                        </span>
                      )}
                      </b>
                  </div>

                  {error.InsuranceIdTxt && <span  className="errorTxt" >{error.InsuranceIdTxt}</span>} 
          </div> 
       
         
          </fieldset>
{
  isEditing ? (<>
  <div className={"saveOptDivBox "}>
          {ShowLoader ? (<>
                      <button  className="   " > Loading
                      <div className="spinner-border text-light  " role="status">
                       <span className="visually-hidden">Loading...</span>
                    </div> 
                    </button>
                    </>):(<>
                      <button onClick={handleSubmitProfile} type="submit" >Save</button>
                    </>)} 
                  <button type="button" onClick={handleCancel}>Cancel</button>
            </div>
  </>) : ('')
}
          
          
        </form>
       
       

                 
      </div>
         </div>
    </div> 
    </div> 
  );
}

export default UserMyInsurance;
